<style>
  .invoice-table td {
    border-top: 0 !important;
    padding: 0px;
    margin: 0;
  }

  .invoice-table h5 {
    width: 150px;
  }
</style>
<div class="app-loading" *ngIf="loading">
  <div class="logo"></div>
  <svg class="spinner" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
  </svg>
  <p class="app-loading-message">{{loadingMessage}}</p>
</div>
<admin-statementEdit (answer)="getAnswer('invoiceEdit', $event)" [invoiceId]="editInvoiceId">
</admin-statementEdit>
<div class="main-content">
  <!-- <ngx-smart-modal #uploadDonationDepositModal identifier="uploadDonationDepositModal" customClass="small-modal">
        <form name="form" (ngSubmit)="f.form.valid && uploadReceiptDeposit()" #f="ngForm" novalidate>
            <small>Salvar Comprovante de Deposito</small>
            <input class="form-control ng-pristine ng-invalid ng-touched" #fileUpload type="file" (change)="fileChangeEvent($event)" placeholder="subir comprovante..." />
            <button type="submit" class="btn btn-info btn-fill">Upload Lista</button>
          </form>
    </ngx-smart-modal> -->
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-3 col-sm-6">
        <div class="card">
          <div class="card-content">
            <div class="row">
              <div class="col-xs-5">
                <div class="icon-big icon-success text-center">
                  <i class="ti-wallet"></i>
                </div>
              </div>
              <div class="col-xs-7">
                <div class="numbers">
                  <p>Receita</p>
                  {{ totalRevenue | number:'.2-2'}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6">
        <div class="card">
          <div class="card-content">
            <div class="row">
              <div class="col-xs-5">
                <div class="icon-big icon-danger text-center">
                  <i class="ti-pulse"></i>
                </div>
              </div>
              <div class="col-xs-7">
                <div class="numbers">
                  <p>Doações</p>
                  {{ totalDonated | number:'.2-2'}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Mensal</h4>
            <div>
              <p class="category">Filtrar por: </p>
              <div (click)="filterStatement('all')" class="pull-left"><span class="label label-info"> Todos</span>
              </div>              
              <div (click)="filterStatement('paid')" class="pull-left"><span class="label label-success">
                  Pago </span></div>
              <div (click)="filterStatement('waiting')" class="pull-left"><span class="label label-warning">
                  Pendente
                </span></div>
              <div (click)="filterStatement('expired')" class="pull-left"><span class="label label-danger">
                  Não Pagou
                </span></div>
              <div (click)="filterStatement('donated')" class="pull-left"><span class="label label-default">
                  Com Doação
                </span></div>
              <div (click)="filterStatement('problem')" class="pull-left"><span class="label label-danger">Problema
                </span></div>
              <div (click)="filterStatement('renovation')" class="pull-left"><span
                  class="label label-success">Renovações
                </span></div>
              <div (click)="filterStatement('iugu')" class="pull-left"><span class="label label-info">Iugu
                </span></div>
              <div (click)="filterStatement('juno')" class="pull-left"><span class="label label-info">Juno
                </span></div>
              <div (click)="filterStatement('hide-carrefour')" class="pull-left"><span class="label label-danger">
                Esconder Carrefour </span></div>
              <div class="col-sm-4">
                <input class="form-control" type="text" placeholder="Pesquise aqui! de Enter" (change)="filterByName()"
                  name="byname" [(ngModel)]="storeFilter.byname" required #byname="ngModel">
              </div>
              <button (click)="showMergeModal()" class="btn btn-sm btn-success pull-right">Merge Faturas</button>
              <button (click)="showManualStatement()" class="btn btn-sm btn-success pull-right">Criar Fatura</button>
              <button (click)="loadFull()" class="btn btn-sm btn-primary pull-right">Carregar Todos</button>
            </div>
          </div>
          <div class="card-content table-full-width" *ngIf="finance != null">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th style="width: 5%">#</th>
                  <th style="width: 20%">Date</th>
                  <th style="width: 25%">MRR</th>
                  <th style="width: 25%">Receita</th>
                  <th style="width: 25%">Doação</th>
                  <th style="width: 10%">Carregar</th>
                </tr>
              </thead>
            </table>
            <div id="acordeon">
              <div class="panel-group" id="accordion">
                <div class="panel panel-border panel-default" *ngFor="let month of finance.monthFinance; let i = index"
                  [attr.data-index]="i">
                  <div>
                    <table style="width: 100%">
                      <tr>
                        <td style="width: 5%" class="text-center"><a data-toggle="collapse" href="#collapse{{i}}"><i
                              class="ti-angle-down"></i></a></td>
                        <td style="width: 20%">{{month.month | date:'MM/yy'}}</td>
                        <td style="width: 25%">R$ {{ (month.mrr + month.mrrFromNotCreateStatement) | number:'1.2-2'}}
                          <br>
                          (ñ criados: R$ {{ month.mrrFromNotCreateStatement | number:'1.2-2'}})
                        </td>
                        <td style="width: 25%">R$
                          {{ (month.revenue + month.revenueFromNotCreateStatement) | number:'1.2-2'}}
                          <br>
                          (ñ criados: R$ {{ month.revenueFromNotCreateStatement | number:'1.2-2'}})
                        </td>
                        <td style="width: 25%">R$ {{month.donation | number:'1.2-2'}}</td>
                        <td style="width: 10%">
                          <button (click)="updateMonth(month.month, $event)"
                            class="btn btn-sm btn-primary pull-right"><i class="ti-reload"></i></button>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div id="collapse{{i}}" class="panel-collapse collapse">
                    <div class="row" style="margin-top: 10px">
                      <div class="col-lg-3 col-sm-6">
                        <div class="card">
                          <div class="card-content">
                            <div class="row">
                              <div class="col-xs-12">
                                <div class="numbers">
                                  <h5>Faturas</h5>
                                  <table class="table" style="font-size: 15px">
                                    <tr>
                                      <td colspan="2">Total</td>
                                      <td>R$ {{month.countInvoices }}</td>
                                      <td>R$ {{month.total | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="2">Total Pago</td>
                                      <td>R$ {{month.countPaid }}</td>
                                      <td>R$ {{month.totalPaid | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="2">Total ñ Pago</td>
                                      <td>R$ {{month.countNotPaid }}</td>
                                      <td>R$ {{month.totalNotPaid | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="2">Total Pendente</td>
                                      <td>R$ {{month.countPending }}</td>
                                      <td>R$ {{month.totalPending | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="2">Total Problema</td>
                                      <td>R$ {{month.countProblem }}</td>
                                      <td>R$ {{month.totalProblem | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="2">Sem Invoice</td>
                                      <td>R$ {{month.countInvoiceless }}</td>
                                      <td>R$ {{month.totalInvoiceless | number:'1.2-2'}}</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6">
                        <div class="card">
                          <div class="card-content">
                            <div class="row">
                              <div class="col-xs-12">
                                <div class="numbers">
                                  <h5>Polen</h5>
                                  <table class="table" style="font-size: 15px">
                                    <tr>
                                      <td>Receita</td>
                                      <td>{{month.countPolen }}</td>
                                      <td>R$ {{month.totalPolen | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Pagas</td>
                                      <td>{{month.countPolenPaid}}</td>
                                      <td>R$ {{month.totalPolenPaid | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Não Pagas</td>
                                      <td>{{month.counPolentNotPaid}}</td>
                                      <td>R$ {{month.totalPolenNotPaid | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Pendentes</td>
                                      <td>{{month.countPolenPending}}</td>
                                      <td>R$ {{month.totalPolenPending | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Problemas</td>
                                      <td>{{month.countPolenProblem}}</td>
                                      <td>R$ {{month.totalPolenProblem | number:'1.2-2'}}</td>
                                      <td>-</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <td>Sem Invoice</td>
                                      <td>{{month.countPolenInvoiceless}}</td>
                                      <td>R$ {{month.totalPolenInvoiceless | number:'1.2-2'}}</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6">
                        <div class="card">
                          <div class="card-content">
                            <div class="row">
                              <div class="col-xs-12">
                                <div class="numbers">
                                  <h5>Doação</h5>
                                  <table class="table" style="font-size: 15px">
                                    <tr>
                                      <td>Pagas</td>
                                      <td>R$ {{month.totalDonationPaid | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Não Pagas</td>
                                      <td>R$ {{month.totalDonationNotPaid | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Pendentes</td>
                                      <td>R$ {{month.totalDonationPending | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Problemas</td>
                                      <td>R$ {{month.totalDonationProblem | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Sem Invoice</td>
                                      <td>R$ {{month.totalDonationInvoiceless | number:'1.2-2'}}</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6">
                        <div class="card">
                          <div class="card-content">
                            <div class="row">
                              <div class="col-xs-12">
                                <div class="numbers">
                                  <h5>MRR</h5>
                                  <table class="table" style="font-size: 15px">
                                    <tr>
                                      <td>MRR</td>
                                      <td>R$ {{month.mrr | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Pago</td>
                                      <td>R$ {{month.mrrPaid | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Ñ Pago</td>
                                      <td>R$ {{month.mrrNotPaid | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Pendente</td>
                                      <td>R$ {{month.mrrPending | number:'1.2-2'}}</td>
                                    </tr>
                                  </table>
                                  <h5>Disponível/Futuro</h5>
                                  <table class="table" style="font-size: 15px">
                                    <tr>
                                      <td>Disponível</td>
                                      <td>R$
                                        {{(month.availableTotal) | number:'1.2-2'}}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Polen Disp.</td>
                                      <td>R$ {{month.availableTotalPolen | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Doações Disp.</td>
                                      <td>R$ {{month.availableTotalDonation | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Total Futuro</td>
                                      <td>R$ {{month.futureTotal | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Polen Futuro</td>
                                      <td>R$ {{month.futureTotalPolen | number:'1.2-2'}}</td>
                                    </tr>
                                    <tr>
                                      <td>Doações Futuro</td>
                                      <td>R$ {{month.futureTotalDonation | number:'1.2-2'}}</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="panel-body">
                      <table class="table" style="background-color: #F3F2EE; font-size: 11px">
                        <thead>
                          <tr>
                            <th>#</th>
                            <!-- <th>#</th> -->
                            <th>Loja</th>
                            <th>MRR</th>
                            <th>Receita</th>
                            <th>Doação</th>
                            <th>Comissão</th>
                            <th>Plano</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let statement of month.statements; let j = index"
                            [hidden]="statement.noStatement || !statement.filterShow"
                            [style.background]="coloredInvoiceLine(statement)">
                            <td style="width:10px">
                              <div (click)="editInvoice(statement)"><i class="fa fa-search"></i></div>{{j + 1}}
                            </td>
                            <!-- <td>{{j + 1}}</td> -->
                            <td>{{ statement.storeName}}
                              <br><span style="color:gray">({{ statement.storePlatformName }})</span>
                              <br><span style="color:gray">({{ statement.code }})</span>
                            </td>
                            <!-- <td>{{ statement.storeEmail}}</td>
                                            <td>{{ statement.invoiceUrl}}</td> -->
                            <td>{{statement.polenMRR | number:'1.2-2'}}</td>
                            <td>{{statement.totalRevenue | number:'1.2-2'}}</td>
                            <td>{{statement.totalDonationApproved | number:'1.2-2'}}
                              <span *ngIf="statement.prePaid > 0"><br>(Pré-Pago: {{statement.finalPrePaid | number:'1.2-2'}})</span>
                            </td>
                            <td>{{ (statement.commissionPercentage * statement.totalDonationApproved ) |
                                              number:'1.2-2'}}</td>
                            <td>
                              <button *ngIf="statement.planSeoName == null" class="btn btn-sm btn-danger btn-fill">Sem
                                Plano</button>
                              <button *ngIf="statement.planSeoName != null"
                                class="btn btn-sm btn-success">{{ statement.planSeoName }}</button>
                            </td>
                            <td>
                              <a *ngIf="statement.statusStatement >= 2 && statement.statusStatement <= 10"
                                (click)="openInvoice(statement)" class="btn btn-xs btn-fill  btn-success">Pago&nbsp;
                                <span *ngIf="statement.statusStatement == 7"> | Ong Pendente</span></a>
                              <a *ngIf="statement.statusStatement == 11" (click)="openInvoice(statement)"
                                class="btn btn-xs btn-fill  btn-danger">Não pagou</a>
                              <a *ngIf="statement.statusStatement == 21" (click)="openInvoice(statement)"
                                class="btn btn-xs btn-fill  btn-danger">Reembolsado</a>
                              <a *ngIf="statement.statusStatement == 12" (click)="openInvoice(statement)"
                                class="btn btn-xs btn-fill  btn-danger">Cancelado</a>
                              <div>
                                <a (click)="chooseCreateInvoiceFromStatement(statement)"
                                  *ngIf="statement.statusStatement == 20 && statement.invoiceType == 1" target="_blank"
                                  class="btn btn-xs  btn-success">Repagar!</a>
                                <a *ngIf="statement.statusStatement == 20" (click)="openInvoice(statement)"
                                  class="btn btn-xs btn-fill  btn-danger">Problema!</a>
                                <div *ngIf="statement.statusStatement == 20 && statement.invoiceType == 0"
                                  class="btn btn-xs btn-fill  btn-primary">iugu</div>
                                <div *ngIf="statement.statusStatement == 20 && statement.invoiceType == 1"
                                  class="btn btn-xs btn-fill  btn-primary">safe2pay</div>
                                <div *ngIf="statement.invoiceType == 5" class="btn btn-xs btn-fill  btn-primary">juno
                                </div>
                              </div>
                              <a *ngIf="statement.statusStatement < 2" (click)="openInvoice(statement)"
                                class="btn btn-xs btn-fill  btn-warning">pendente</a>
                              <button *ngIf="statement.invoiceUrl == null || statement.invoiceUrl == ''"
                                class="btn btn-xs  btn-danger"> Sem fatura <span *ngIf="!statement.invoiceSent"> | ñ
                                  enviado</span></button>
                              <a (click)="chooseCreateInvoiceFromStatement(statement)"
                                *ngIf="statement.invoiceUrl == null || statement.invoiceUrl == ''"
                                class="btn btn-xs  btn-success">Gerar Invoice</a>
                              <a style="float:right" (click)="deleteStatement(statement,$event)"
                                class="btn btn-xs btn-danger" title="Deletar Fatura"><i class="fa fa-close"></i></a>
                              <a *ngIf="(statement.taxStatementId == null || statement.taxStatementId == '') && statement.invoiceId != null"
                                style="float:right" (click)="createTaxStatement(statement,$event)"
                                class="btn btn-xs btn-warning">Gerar NF</a>
                              <!-- <a style="float:right" (click)="createTaxStatement(statement)" class="btn btn-xs btn-warning">Gerar NF</a> -->
                              <a *ngIf="(statement.taxStatementUrl == null || statement.taxStatementUrl == '') && statement.taxStatementId != null && statement.taxStatementId != 'no-nf-required'"
                                style="float:right" target="_blank"
                                href="https://api.nfe.io/v1/companies/5c3dde05d41d7c1da479c8ed/serviceinvoices/{{ statement.taxStatementId }}/pdf?apiKey=ICXlatZNOcWxDDfRxYkErBCiCqIVuk2KpNV47oRuqLnXDpSrDye01UjHYK2Uc2ZbqN7"
                                class="btn btn-xs btn-success">NF Emitida</a>
                              <a *ngIf="statement.taxStatementId == 'no-nf-required'" style="float:right"
                                target="_blank" class="btn btn-xs btn-success">Apenas Doação</a>
                              <a *ngIf="statement.taxStatementUrl != null" style="float:right" target="_blank"
                                href="{{statement.taxStatementUrl }}" class="btn btn-xs btn-success">NF Emitida
                                Manual</a>
                            </td>
                          </tr>
                          <tr *ngFor="let statement of month.statements; let j = index"
                            [hidden]="!statement.noStatement">
                            <td>{{j + 1}}</td>
                            <td>{{ statement.storeName}}
                              <br><span style="color:gray">({{ statement.storePlatformName }})</span>
                            </td>
                            <td>R$ {{statement.polenMRR | number:'1.2-2'}}</td>
                            <td>R$ {{statement.polenSubscription | number:'1.2-2'}}</td>
                            <td colspan="2">
                              <a *ngIf="statement.planSeoName != null && (statement.planSeoName.indexOf('semestral') >= 0 || statement.planSeoName.indexOf('anual') >= 0)"
                                class="btn btn-xs btn-fill btn-success">Pago</a>
                              <span
                                *ngIf="statement.planSeoName != null && (statement.planSeoName.indexOf('semestral') < 0 && statement.planSeoName.indexOf('anual') < 0)">
                                invoice ñ foi criada. ({{statement.planSeoName}})</span>
                            </td>
                            <td>
                              <a (click)="createStatementAsk(statement,month.month)"
                                *ngIf="statement.polenSubscription > 0 && statement.invoiceUrl == null"
                                class="btn btn-xs  btn-success">Gerar Fatura</a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ngx-smart-modal #mergeModal identifier="mergeModal">
      <h4 class="card-title" style="text-align: center">Merge de 2 ou mais faturas</h4>
      <p>Insira os IDs das faturas que deseja dar o Merge no campo abaixo, mas lembre-se: <b>Com grandes poderes, vem
          grandes responsabilidades!</b></p>
      <img style="width: 100%"
        src="https://kanto.legiaodosherois.com.br/w750-h1200/wp-content/uploads/2017/11/legiao_dmQOfITyhPbVi7skAWcvqYeZMrj9F3KUaJwRBHGl6g.jpg" />
      <table class="table table-striped">
        <tbody>
          <tr>
            <td>
              <form name="form" (ngSubmit)="f.form.valid" #f="ngForm" novalidate>
                <div class="form-group">
                  IDs das faturas:
                  <input class="form-control" type="text" placeholder="IDs, separados por virgula" name="mergeIdList"
                    [(ngModel)]="storeFilter.mergeIdList" required #mergeIdList="ngModel">
                  <br>
                  IdUrl da loja:
                  <input class="form-control" type="text" placeholder="id da loja" name="byname"
                    [(ngModel)]="storeFilter.byname" required #byname="ngModel">
                  <br>
                </div>
              </form>
            </td>
          </tr>
      </table>
    </ngx-smart-modal>
    <ngx-smart-modal #manualStatementModal identifier="manualStatementModal" style="background: #c2c2c220;">
      <h4 class="card-title" style="text-align: center">Nova fatura</h4>
      <p>Crie uma nova fatura adicionando os ids de loja, ong, etc...</p>
      <div *ngIf="manualInvoice != null">
        <div class="col-lg-12 col-md-12">
          <div class="card">
            <div class="card-content">
              <form name="form" (ngSubmit)="f.form.valid" #f="ngForm" novalidate>
                <div class="form-group">
                  SeoUrl da loja:
                  <input class="form-control" type="text" placeholder="IDs, separados por virgula" name="seoUrl"
                    [(ngModel)]="manualInvoice.seoUrl" required #seoUrl="ngModel">
                  <br>
                  Data (em branco para ser a data de hoje)
                  <input class="form-control" type="text" placeholder="dd/mm/yyyy" name="date"
                    [(ngModel)]="manualInvoice.date" #date="ngModel" class="form-control" />
                  <br>
                  Plano:
                  <input class="form-control" type="text" placeholder="bloomer-6-semestral por exemplo"
                    name="planSeoName" [(ngModel)]="manualInvoice.planSeoName" required #planSeoName="ngModel">
                  <br>
                  Receita:
                  <input class="form-control" type="text" name="revenue" currencyMask
                    [(ngModel)]="manualInvoice.revenue" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    #revenue="ngModel" placeholder="R$0,00" style="text-align: left !important;" required />
                  <br>
                  MRR:
                  <input class="form-control" type="text" name="mrr" currencyMask [(ngModel)]="manualInvoice.mrr"
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" #mrr="ngModel" placeholder="R$0,00"
                    style="text-align: left !important;" required />
                  <br>
                  Comissão:
                  <input class="form-control" type="text" placeholder="'10 por exemplo = 10%'"
                    name="commissionPercentage" [(ngModel)]="manualInvoice.commissionPercentage" required
                    #commissionPercentage="ngModel">
                  <small>Caso seja valor fixo, deixar em branco</small>
                  <br>
                  <br>
                  Pagamento Único? (ñ recorrente)
                  <input type="checkbox" name="manualInvoice.oneTimePayment" [(ngModel)]="manualInvoice.oneTimePayment"
                    #oneTimePayment="ngModel" [checked]="manualInvoice.oneTimePayment" [value]="false" />
                </div>
                <hr>
                <p style="text-align: center;">Outras informações você pode completar ao editar.</p>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12">
          <div class="card">
            <h4 class="card-header">Adicionar doação para Ong</h4>
            <small>Para fazer uma fatura com doação é necessário associar a doação ao ID da instituição. O id você
              encontra em <a href="https://polen.com.br/ongs">polen.com.br/ongs</a></small>
            <div class="card-content">
              <div class="row" *ngFor="let ngo of manualInvoice.ngos;let i = index">
                <div class="col-lg-6 col-md-12">
                  <input [(ngModel)]="manualInvoice.ngos[i].ngoUrl" name="ngoUrl" #ngoUrl="ngModel"
                    class="form-control col-lg-4 col-sm-4" placeholder="ngoUrl">
                </div>
                <div class="col-lg-6 col-md-12">
                  <input [(ngModel)]="manualInvoice.ngos[i].donation" name="donation" #donation="ngModel"
                    class="form-control col-lg-4 col-sm-4" placeholder="donation">
                </div>
              </div>
              <hr>
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-6 col-md-12">
                    Tem doação?
                    <input type="checkbox" name="manualInvoice.hasDonation" [(ngModel)]="manualInvoice.hasDonation"
                      #hasDonation="ngModel" [checked]="manualInvoice.hasDonation" [value]="false" />
                  </div>
                  <div class="col-lg-6 col-md-12 text-right">
                    <button class="btn btn-info btn-sm" type="button" (click)="manualInvoiceSetNgo('plus')"> +
                      ong</button>
                    <button class="btn btn-info btn-sm" type="button" (click)="manualInvoiceSetNgo('less')"> -
                      ong</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12">
          <div class="form-group text-right">
            <button class="btn btn-info btn-fill" type="button" (click)="createManualStatement()">Criar Fatura</button>
          </div>
        </div>
      </div>
    </ngx-smart-modal>
  </div>